module.exports = __webpack_public_path__ + "img/v-2.50444dc9.svg";